<template>
	<div class="fullscreen-loader is-flex is-flex-direction-column">
		<div class="blur-background"></div>
		<div class="loader-container">
			<div class="loader"></div>
		</div>
		<div class="columns mt-3">
			<div class="column has-text-weight-bold has-text-centered">
				{{ loadingText }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['loadingText']
}
</script>

<style scoped>
.fullscreen-loader
{
	position: fixed;
	top: 72px;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.blur-background
{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: inherit;
	backdrop-filter: blur(5px);
	z-index: -1;
}

.loader-container
{
	text-align: center;
}

.loader
{
	border: 5px solid #f3f3f3;
	border-top: 5px solid black;
	border-radius: 50%;
	width: 80px;
	height: 80px;
	animation: spin 1s linear infinite;
}

@keyframes spin
{
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>
